/**
 * Admin Profile / Change Password Logic
 */
export function initProfile() {
    initPasswordToggle();
    initPasswordStrength();
    initPasswordMatch();
}

function initPasswordToggle() {
    $(document).on('click', '.toggle-pw', function() {
        const targetId = $(this).data('target');
        const target = document.getElementById(targetId);
        const icon = this.querySelector('i');
        if (target.type === 'password') {
            target.type = 'text';
            icon.classList.replace('bi-eye', 'bi-eye-slash');
        } else {
            target.type = 'password';
            icon.classList.replace('bi-eye-slash', 'bi-eye');
        }
    });
}

function initPasswordStrength() {
    const newPw = document.getElementById('newPw');
    const strengthDiv = document.getElementById('passwordStrength');
    if (!newPw || !strengthDiv) return;

    newPw.addEventListener('input', function() {
        const val = this.value;
        let strength = 0;
        if (val.length === 0) { strengthDiv.innerHTML = ''; return; }
        if (val.length >= 8) strength++;
        if (val.length >= 12) strength++;
        if (/[A-Z]/.test(val)) strength++;
        if (/[0-9]/.test(val)) strength++;
        if (/[^A-Za-z0-9]/.test(val)) strength++;

        let label, color;
        if (strength <= 2) { label = 'Lemah'; color = '#dc3545'; }
        else if (strength <= 3) { label = 'Sedang'; color = '#ffc107'; }
        else { label = 'Kuat'; color = '#28a745'; }

        const pct = (strength / 5) * 100;
        strengthDiv.innerHTML = `
            <div class="d-flex align-items-center gap-2">
                <div class="progress flex-grow-1" style="height: 5px; border-radius: 3px;">
                    <div class="progress-bar" style="width: ${pct}%; background: ${color}; transition: width 0.3s;"></div>
                </div>
                <span class="small fw-bold" style="color: ${color}; min-width: 50px;">${label}</span>
            </div>`;
    });
}

function initPasswordMatch() {
    const newPw = document.getElementById('newPw');
    const confirmPw = document.getElementById('confirmPw');
    const matchFeedback = document.getElementById('matchFeedback');
    if (!newPw || !confirmPw || !matchFeedback) return;

    confirmPw.addEventListener('input', function() {
        if (this.value === '') matchFeedback.innerHTML = '';
        else if (this.value === newPw.value) matchFeedback.innerHTML = '<span class="text-success"><i class="bi bi-check-circle-fill me-1"></i>Password cocok</span>';
        else matchFeedback.innerHTML = '<span class="text-danger"><i class="bi bi-x-circle-fill me-1"></i>Password tidak cocok</span>';
    });
}
